import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';

import { Advertiser } from '../../../_models';
import { NotificationService, EnvService, AdvertiserService } from '../../../_services';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-advertiser-detail',
  templateUrl: './advertiser-detail.component.html',
  styleUrls: []
})
export class AdvertiserDetailComponent implements OnInit {

  advertiser: Advertiser = null;
  timezones: any = [];
  loaded = false;
  loading = true;
  processing = false;

  saveNew = false;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private advertiserSvc: AdvertiserService,
    private notification: NotificationService,
    private modalService: NgbModal) {

  }

  ngOnInit(): void {
    this.timezones.push("Asia/Kuala_Lumpur");

    let id = this.route.snapshot.paramMap.get('id');
    if(id == "-1"){
      this.saveNew = true;
      this.advertiser = new Advertiser();
      this.advertiser.min = 0;
      this.advertiser.max = 0;
      this.advertiser.rate = 100;
      this.advertiser.timezone = this.timezones[0];
      this.loaded = true;
      this.loading = false;

    }else{
      this.saveNew = false;
      this.loadDetail(id);
    }

  }

  save() {
    this.processing = true;
    if (confirm("Are you sure to add this advertiser?")) {
      this.advertiserSvc.addAdvertiser(this.advertiser).subscribe(data => {
        if (data !== null) {
          if (data.status == 1) {
            this.notification.showSuccess("Advertiser added successfully!", "Added Advertiser");
            this.modalService.dismissAll();
            this.back();
          } else {
            this.notification.showError(data.msg, "Fail add");
          }
        } else {
          this.notification.showError("Failed to add advertiser, please try again later.", "Fail add");
        }
      });
      this.processing = false;
    } else {
      this.processing = false;
    }
  }

  update() {
    this.processing = true;
    if (confirm("Are you sure to update this advertiser?")) {
      this.advertiserSvc.updateAdvertiser(this.advertiser).subscribe(data => {
        if (data !== null) {
          if (data.status == 1) {
            this.notification.showSuccess("Advertiser updated successfully!", "Update Advertiser");
            this.modalService.dismissAll();
          } else {
            this.notification.showError(data.msg, "Fail update");
          }

        } else {
          this.notification.showError("Failed to update advertiser, please try again later.", "Fail update");
        }
      });
      this.processing = false;
    } else {
      this.processing = false;
    }
  }

  back() {
    this.router.navigate(['/dashboard/offer-stream/advertiser']);
  }

  private loadDetail(id) {
    this.advertiserSvc.getAdvertiser(id).subscribe(data => {
      this.advertiser = data
      this.loaded = true;
      this.loading = false;
    });
  }

}
